import { Link } from "react-router-dom";
import { useCurrency } from "@/context/CurrencyContext";

const gbp = (n) => `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0 })}`;

export default function ProductCard({ product }) {
    const sold = product.status === "sold";
    const { format, currency } = useCurrency();
    const priceFmt = format(product.price);
    return (
        <Link
            to={`/product/${product.id}`}
            className={`product-card ${sold ? "sold" : ""}`}
            data-testid={`product-card-${product.id}`}
        >
            <div className="img-wrap">
                {product.condition === "Pristine" && !sold && (
                    <div className="badge">Pristine</div>
                )}
                {(product.images || []).length > 0 ? (
                    <img src={product.images[0]} alt={product.title} loading="lazy" />
                ) : (
                    <div style={{ background: "var(--parchment-soft)", width: "100%", height: "100%" }} />
                )}
            </div>
            <div className="meta">
                <div className="designer">{product.designer}</div>
                <div className="title">{product.title}</div>
                <div className="price">
                    {product.original_price && product.original_price > product.price && (
                        <s>{gbp(product.original_price)}</s>
                    )}
                    {gbp(product.price)}
                </div>
                {priceFmt.reference && currency !== "GBP" && (
                    <div
                        data-testid={`product-card-price-ref-${product.id}`}
                        style={{
                            fontFamily: "var(--font-sans)", fontSize: 10, letterSpacing: "0.16em",
                            textTransform: "uppercase", color: "var(--cocoa)", opacity: 0.6, marginTop: 2,
                        }}
                    >
                        {priceFmt.reference}
                    </div>
                )}
            </div>
        </Link>
    );
}
